var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 15 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 26.0001C13.3682 26.0001 13.7281 25.891 14.0341 25.6865C14.3402 25.482 14.5788 25.1913 14.7196 24.8513C14.8605 24.5112 14.8974 24.137 14.8255 23.776C14.7537 23.415 14.5764 23.0833 14.3161 22.8231L4.49415 13.0001L14.3151 3.17908C14.6644 2.82992 14.8607 2.35631 14.8608 1.86244C14.8609 1.36856 14.6648 0.894872 14.3156 0.545582C13.9665 0.196292 13.4929 9.87847e-06 12.999 -8.38897e-05C12.5051 -0.000177658 12.0314 0.195924 11.6821 0.545082L0.545149 11.6811C0.372317 11.8539 0.235217 12.0591 0.14168 12.2849C0.0481431 12.5107 0 12.7527 0 12.9971C0 13.2415 0.0481431 13.4835 0.14168 13.7093C0.235217 13.9351 0.372317 14.1403 0.545149 14.3131L11.6821 25.4501C11.8546 25.6243 12.0599 25.7626 12.2861 25.857C12.5123 25.9514 12.755 26 13.0001 26.0001Z",
    fill: "#3D505A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon-arrow-left.15f6237b7a74d1eadf46bfaf1d6ad831.svg";
export { ForwardRef as ReactComponent };